import { PrimaryButton, IButtonProps } from "@fluentui/react/lib/Button";
import { Stack } from "@fluentui/react/lib/Stack";

import { isNotNullOrWhiteSpace } from "Utils/String";
import { generateUniqueId } from "Utils/UniqueId";
import { useHeaderButtonStyles } from "./UseHeaderButtonStyles";
import { IHeaderButtonProps } from "./IHeaderButtonProps";

export function HeaderButton(props: IHeaderButtonProps): JSX.Element {
  const { buttonAreaWidth, buttonIcon, buttonText } = props;
  const styles = useHeaderButtonStyles(buttonAreaWidth);

  const hasFirstButton = hasButton(buttonText, buttonIcon);
  return hasFirstButton && <Stack.Item className={styles.root}>{getButton(props, styles.button)}</Stack.Item>;
}

function getButton(props: IHeaderButtonProps, buttonStyles: string) {
  const { buttonIcon, buttonText, onButtonClick } = props;
  return (
    <PrimaryButton
      onClick={onButtonClick}
      disabled={onButtonClick == null}
      className={buttonStyles}
      iconProps={{ iconName: buttonIcon }}
      {...getSplitButton(props)}
    >
      {buttonText}
    </PrimaryButton>
  );
}

function getSplitButton(props: IHeaderButtonProps): Partial<IButtonProps> {
  const { onSplitButtonClick, splitButtonIcon, splitButtonText } = props;
  const hasSplitButton = hasButton(splitButtonText, splitButtonIcon);
  if (!hasSplitButton) {
    return {};
  }

  return {
    split: true,
    menuProps: {
      items: [
        {
          key: generateUniqueId(true),
          text: splitButtonText,
          iconProps: { iconName: splitButtonIcon },
          onClick: onSplitButtonClick
        }
      ]
    }
  };
}

function hasButton(text: string, icon: string): boolean {
  return isNotNullOrWhiteSpace(text) || isNotNullOrWhiteSpace(icon);
}
